// Zénith Plage — données du site

export const BRAND = {
  name: "Zénith Plage",
  tagline: "Nouvelle vague. Nouvelle identité.",
  baseline: "Plage privée — Palavas-les-Flots",
  phone: "06 09 97 63 65",
  phoneHref: "tel:+33609976365",
  email: "zenithplage@gmail.com",
  emailHref: "mailto:zenithplage@gmail.com",
  address: {
    line1: "Avenue de l'Évêché de Maguelone",
    line2: "34250 Palavas-les-Flots",
    mapsUrl:
      "https://www.google.com/maps/search/?api=1&query=Z%C3%A9nith+Plage+Avenue+de+l%27%C3%89v%C3%AAch%C3%A9+de+Maguelone+34250+Palavas-les-Flots",
  },
  hours: "Tous les jours · 8h — 1h",
  instagramUrl: "https://www.instagram.com/zenithplage/",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_coastal-oasis-1/artifacts/slrnmfz0_IMG_3216.jpeg",
};

export const NAV_LINKS = [
  { label: "À propos", href: "#apropos" },
  { label: "Services", href: "#services" },
  { label: "Carte", href: "#carte" },
  { label: "Galerie", href: "#galerie" },
  { label: "Contact", href: "#contact" },
];

// Real Zénith Plage photography provided by the team
const ASSET_BASE =
  "https://customer-assets.emergentagent.com/job_coastal-oasis-1/artifacts";

export const PHOTOS = {
  sunsetTerrace: `${ASSET_BASE}/ywbn2r4n_IMG_3218.jpeg`, // terrasse coucher de soleil
  beachLoungers: `${ASSET_BASE}/0r1m1www_IMG_3219.jpeg`, // transats bleus + parasols rayés
  tuna: `${ASSET_BASE}/c428onao_IMG_3220.jpeg`, // thon entier en cuisine
  spritz: `${ASSET_BASE}/b8wed0z9_IMG_3221.jpeg`, // 2 spritz au bar
  newspaper: `${ASSET_BASE}/loi5s2i8_IMG_3222.jpeg`, // femme journal sous parasol
  dessert: `${ASSET_BASE}/3a8h1fuo_IMG_3223.jpeg`, // dessert assiette noire
  tartare: `${ASSET_BASE}/barywcyx_IMG_3224.jpeg`, // tartare en coque
};

export const IMAGES = {
  hero: PHOTOS.sunsetTerrace,
  about: PHOTOS.newspaper,
  serviceRestaurant: PHOTOS.tartare,
  serviceBar: PHOTOS.spritz,
  serviceBeach: PHOTOS.beachLoungers,
  gallery: [
    PHOTOS.beachLoungers,
    PHOTOS.sunsetTerrace,
    PHOTOS.tartare,
    PHOTOS.spritz,
    PHOTOS.dessert,
    PHOTOS.tuna,
  ],
};

export const SERVICES = [
  {
    id: "restauration",
    eyebrow: "Service midi & soir",
    title: "Restauration",
    description:
      "Une cuisine méditerranéenne, généreuse et iodée. Produits frais, poissons grillés, plats de partage et desserts maison — servis face à la mer, midi et soir.",
    image: PHOTOS.tartare,
    cta: "Voir la carte",
    href: "#carte",
  },
  {
    id: "transats",
    eyebrow: "Confort & farniente",
    title: "Transats & Parasols",
    description:
      "Posez votre serviette, on s'occupe du reste. Transats en location à l'heure ou à la journée, parasols rayés bleu et blanc, service en pieds dans le sable.",
    image: PHOTOS.beachLoungers,
    cta: "Voir les tarifs",
    href: "#tarifs",
  },
  {
    id: "bar",
    eyebrow: "Bar de plage",
    title: "Cocktails & Apéros",
    description:
      "Cocktails signatures aux agrumes, vins frais, bières pression et softs. L'heure dorée prend une autre dimension, un verre à la main, les pieds dans l'eau.",
    image: PHOTOS.spritz,
    cta: "Découvrir le bar",
    href: "#carte",
  },
];

export const TARIFS = [
  { label: "Transat — La journée", price: "20 €" },
  { label: "Transat — L'heure", price: "5 €" },
  { label: "Parasol (supplément)", price: "+2 €" },
];

// Real menu — Zénith Plage
export const MENU = {
  tapas: {
    groups: [
      {
        title: "Tapas",
        items: [
          { name: "Chorizos grillés", price: "10" },
          { name: "Antipasti", desc: "Aubergines, courgettes, poivrons et tomates séchées", price: "15" },
          { name: "Camembert rôti au thym et miel", price: "16" },
          { name: "Palourdes à la crème d'ail", price: "18" },
          { name: "Potatoes", price: "8" },
          { name: "Couteaux en persillade", price: "18" },
          { name: "Salade de poulpe", desc: "Mariné au citron vert, herbes fraîches et olives noires", price: "18" },
          { name: "Bouquet de crevettes", price: "18" },
        ],
      },
      {
        title: "Salades",
        items: [
          { name: "Pokéball", desc: "Mélange de quinoa et lentilles bélouga, concombres, choux rouge façon pickles, saumon mariné, choux de Pékin assaisonné, oignons rouges et vinaigrette asiatique, gingembre confit et graines de sésame", price: "22" },
          { name: "Salade César", desc: "Poulet mariné aux épices, croûtons, copeaux de parmesan, œuf dur et sauce César", price: "22" },
          { name: "Salade de la mer", desc: "Crevettes, poulpe et tartare de saumon aux agrumes", price: "24" },
        ],
      },
      {
        title: "Planches",
        items: [
          { name: "Planche de charcuteries", price: "18" },
          { name: "Planche de fromages", price: "18" },
          { name: "Planche mixte", desc: "Charcuteries et fromages", price: "25" },
          { name: "Pan con tomate, jambon serrano", price: "18" },
          { name: "Pan con tomate végétarien", price: "12" },
        ],
      },
    ],
  },
  entreesPlats: {
    groups: [
      {
        title: "Entrées",
        items: [
          { name: "Tartare de saumon", desc: "Condiments et salade — environ 200 grammes", price: "24" },
          { name: "Gravlax de saumon", desc: "Crème citron vert", price: "22" },
          { name: "Tomate rôtie & burrata", desc: "Pesto de basilic et amandes", price: "18" },
          { name: "Tourteau entier et son aïoli", price: "30" },
        ],
      },
      {
        title: "Plats",
        items: [
          { name: "Filet de bœuf façon Rossini", desc: "Aubrac, jus de viande réduit, légumes glacés au beurre — environ 210 grammes", price: "38" },
          { name: "Duo de sèche et gambas", desc: "À la plancha, bisque de crustacés, légumes croquants", price: "32" },
          { name: "Médaillons de lotte", desc: "Fumet crémé et citron confit", price: "32" },
          { name: "Loup ou dorade entière", desc: "À la plancha, huile d'olive, herbes fraîches, légumes de saison", price: "32" },
          { name: "Menu enfant", desc: "Steak haché ou filet de poisson frais, écrasé de pomme de terre, boisson et glace", price: "16" },
        ],
      },
    ],
  },
  desserts: {
    groups: [
      {
        title: "Desserts",
        items: [
          { name: "Cœur coulant au chocolat", desc: "Chocolat noir Inaya, fruits rouges au vinaigre de framboise et crème fouettée", price: "10" },
          { name: "Tarte Tatin façon Zénith", desc: "Une boule vanille en supplément (+ 2 €)", price: "10" },
          { name: "Salade de fruits frais", desc: "Au sirop de pêche", price: "10" },
          { name: "Tiramisu café Amaretto", price: "10" },
          { name: "Assiette de fromages", desc: "Sélection du moment", price: "10" },
        ],
      },
      {
        title: "Coupes alcoolisées",
        items: [
          { name: "Colonel", desc: "2 boules citron vert, 1 boule citron jaune et vodka (4 cl)", price: "15" },
          { name: "Passionata", desc: "2 boules mangue, 1 boule noix de coco, fruits frais et rhum (4 cl)", price: "15" },
        ],
      },
      {
        title: "Glaces",
        note: "1 boule 3 € · 2 boules 5,5 € · 3 boules 8 €",
        items: [
          { name: "Coupe au choix", desc: "Fraise, framboise, cassis, citron, citron vert, mangue, passion, vanille, caramel au beurre salé, chocolat, café, coco", price: "à la carte" },
          { name: "Dame Blanche", desc: "3 boules vanille, coulis chocolat et crème chantilly", price: "13" },
          { name: "Café liégeois", desc: "3 boules café, expresso rafraîchi, coulis café et crème chantilly", price: "13" },
          { name: "Chocolat liégeois", desc: "3 boules chocolat, coulis chocolat et crème chantilly", price: "13" },
        ],
      },
      {
        title: "Boissons chaudes",
        items: [
          { name: "Expresso", price: "3" },
          { name: "Décaféiné ou noisette", price: "3" },
          { name: "Double expresso", price: "4,5" },
          { name: "Grand crème", price: "4,5" },
          { name: "Chocolat chaud", price: "4,5" },
          { name: "Thé ou infusion", desc: "Thé noir Ceylan, thé noir Earl Grey, thé vert de Chine, infusion verveine", price: "4" },
          { name: "Café frappé", price: "6" },
          { name: "Irish coffee", price: "12" },
        ],
      },
    ],
  },
  cocktails: {
    groups: [
      {
        title: "Base Rhum",
        note: "4 cl",
        items: [
          { name: "Mojito", desc: "Rhum Saint James — classique, fraise, framboise ou passion", price: "12" },
          { name: "Spicy Mojito", desc: "Gingembre, citron vert, menthe", price: "12" },
          { name: "Caïpirinha", desc: "Cachaça Aguacana — classique, fraise, framboise ou passion", price: "12" },
          { name: "Cuba Libre", desc: "Rhum Saint-James, citron vert, cassonade, cola", price: "12" },
          { name: "Punch maison", desc: "Type planteur", price: "5 / 25" },
          { name: "Piña Colada", desc: "Crème de coco, jus d'ananas", price: "12" },
        ],
      },
      {
        title: "Base Tequila",
        note: "4 cl",
        items: [
          { name: "Margarita", desc: "Triple sec, citron vert", price: "12" },
          { name: "Tequila Sunrise", desc: "Jus d'orange, sirop de grenade", price: "12" },
        ],
      },
      {
        title: "Base Vodka",
        note: "4 cl",
        items: [
          { name: "Caïpirovska", desc: "Classique, fraise, framboise ou passion", price: "12" },
          { name: "Cosmo", desc: "Vodka Sobieski, liqueur de pêche Marie Brizard, cranberry, triple sec, citron", price: "12" },
          { name: "Sex on Zénith", desc: "Vodka, liqueur de pêche Marie Brizard, cranberry, ananas", price: "12" },
          { name: "Expresso Martini", desc: "Vodka, liqueur de café Marie Brizard, expresso", price: "14" },
          { name: "Framboisine", desc: "Vodka Sobieski, liqueur de framboise, cranberry", price: "12" },
        ],
      },
      {
        title: "Base Gin",
        note: "4 cl",
        items: [
          { name: "Gin Fizz", desc: "Gin, citron jaune, sucre de canne", price: "12" },
          { name: "Gin Cucumber", desc: "Gin, concombre, tonic", price: "12" },
          { name: "Tropical Gin Punch", desc: "Ananas, mangue, citron vert, sucre de canne", price: "12" },
        ],
      },
      {
        title: "Spritz Signature",
        items: [
          { name: "Aperol Spritz", desc: "Prosecco, Aperol, eau pétillante, orange", price: "12" },
          { name: "Campari Spritz", desc: "Prosecco, Campari, eau pétillante", price: "12" },
          { name: "Saint-Germain Spritz", desc: "Prosecco, St-Germain, citron vert, menthe", price: "14" },
          { name: "Limoncello Spritz", desc: "Prosecco, Limoncello, eau pétillante", price: "12" },
        ],
      },
      {
        title: "Mules",
        items: [
          { name: "Moscow Mule", desc: "Vodka, citron vert, ginger beer", price: "12" },
          { name: "London Mule", desc: "Gin, citron vert, ginger beer", price: "12" },
          { name: "Mexican Mule", desc: "Tequila 100% agave, citron vert, ginger beer", price: "12" },
        ],
      },
      {
        title: "Sans Alcool",
        items: [
          { name: "Apple Mojito", desc: "Citron vert, menthe, jus de pomme", price: "8" },
          { name: "Mango", desc: "Mangue, orange, purée de passion", price: "8" },
          { name: "Zénith", desc: "Purée de fraise, passion, cranberry, ananas", price: "8" },
          { name: "Thé glacé", desc: "Citron, framboise ou pêche", price: "5,5" },
        ],
      },
      {
        title: "Sangria",
        items: [
          { name: "Sangria rouge maison", desc: "20 cl", price: "6" },
        ],
      },
    ],
  },
  boissons: {
    groups: [
      {
        title: "Apéritifs",
        items: [
          { name: "Ricard, Pastis, Casanis", desc: "2 cl", price: "4" },
          { name: "Martini Rosso, Bianco", desc: "5 cl", price: "5" },
          { name: "Kir vin blanc", desc: "12 cl", price: "5" },
        ],
      },
      {
        title: "Champagne",
        items: [
          { name: "Champagne AOC", desc: "12 cl", price: "12" },
          { name: "Minard Ondine Brut", desc: "12,5 cl", price: "12" },
          { name: "Bouteille", desc: "75 cl", price: "80" },
        ],
      },
      {
        title: "Alcools",
        note: "4 cl",
        items: [
          { name: "Whisky", price: "9" },
          { name: "Jack Daniel's", price: "10" },
          { name: "Get 27, Limoncello, Bailey's", price: "9" },
          { name: "Gin, Vodka, Tequila, Rhum", price: "9" },
          { name: "Cognac, Armagnac", price: "12" },
          { name: "Zacapa", price: "12" },
          { name: "Diplomatico", price: "12" },
          { name: "Marie Sérum", price: "12" },
        ],
      },
      {
        title: "Bières",
        note: "33 cl",
        items: [
          { name: "Heineken", price: "5" },
          { name: "Desperados, Corona", price: "7" },
          { name: "Bière sans alcool", price: "7" },
          { name: "Bière artisanale", desc: "Blonde ou blanche", price: "7" },
        ],
      },
      {
        title: "Vins — IGP Pays d'Oc",
        note: "12 cl · 25 cl · 50 cl",
        items: [
          { name: "Cinsault — rosé", price: "4,5 / 7,5 / 12" },
          { name: "Sauvignon — blanc", price: "4,5 / 7,5 / 12" },
          { name: "Merlot — rouge", price: "4,5 / 7,5 / 12" },
        ],
        footnote: "Carte des vins complète disponible sur demande.",
      },
      {
        title: "Softs",
        items: [
          { name: "Eau plate ou gazeuse", desc: "75 cl", price: "7" },
          { name: "Canette", desc: "Coca, Coca Zéro, Coca Cherry, Fanta, Troppico, Limonade, Liptonic, Orangina, Ice Tea, Perrier, Minute Maid Pomme — 33 cl", price: "4,5" },
          { name: "Schweppes Tonic ou Agrumes", desc: "33 cl", price: "4,5" },
          { name: "Boisson énergétique", desc: "25 cl", price: "5" },
          { name: "Diabolo parfums variés", desc: "33 cl", price: "4,5" },
          { name: "Fruit pressé", desc: "Orange, citron ou pamplemousse", price: "8" },
          { name: "Mix fruits", desc: "Mélange d'agrumes", price: "8" },
          { name: "Jus de tomate", desc: "25 cl", price: "4,5" },
          { name: "Sirop à l'eau", desc: "Parfums variés — 33 cl", price: "3,5" },
          { name: "Jus Maya", desc: "Litchi, ananas, coco, goyave ou PAM — 33 cl", price: "7" },
        ],
      },
    ],
  },
};

export const MENU_TABS = [
  { id: "tapas", label: "Tapas & Salades" },
  { id: "entreesPlats", label: "Entrées & Plats" },
  { id: "desserts", label: "Desserts & Glaces" },
  { id: "cocktails", label: "Cocktails" },
  { id: "boissons", label: "Boissons & Vins" },
];
